import { useLoaderData } from 'react-router';
import { BackLink } from '@/components/back-link';
import { api } from '@/lib/api';
import { CampaignForm } from './campaign-form';

export async function newCampaignLoader() {
  const [templates, segments] = await Promise.all([
    api<{ id: string; name: string; kind: string; testSentAt: string | null }[]>('/templates'),
    api<{ id: string; name: string; kind: string; memberCount: number }[]>('/segments'),
  ]);
  return { templates, segments };
}

export function NewCampaignPage() {
  const { templates, segments } = useLoaderData<typeof newCampaignLoader>();
  return (
    <div className="space-y-5">
      <BackLink to="/campaigns">Campaigns</BackLink>
      <h1 className="text-2xl">New campaign</h1>
      <CampaignForm templates={templates} segments={segments} />
    </div>
  );
}
